var fmt = require("../lib/format");
global.CKEDITOR_BASEPATH = fmt.url("/ckeditor45/");

export function setup() {
  if (luvit.IsTouchDevice()) {
    CKEDITOR.config.toolbar_Basic = [
      ["Bold", "Italic", "Underline"],
      ["BulletedList"],
    ];
    CKEDITOR.config.toolbar = "Basic";
    CKEDITOR.config.width = "100%";
    CKEDITOR.config.height = 200;
    CKEDITOR.env.isCompatible = true;
  }
}

export function load() {
  return new Promise((success, error) => {
    require.ensure([], function () {
      require("../../../ckeditor45/ckeditor.js");
      setup();
      success(CKEDITOR);
    });
  });
}
